import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { assistantApi } from "@/lib/api/assistant";
import { ApiError } from "@/lib/api/client";
import { clearAuthToken, getAuthToken } from "@/lib/auth/storage";

export function AuthGuard() {
  const token = getAuthToken();
  const [status, setStatus] = useState<"checking" | "ok" | "denied">(
    token ? "checking" : "denied"
  );

  useEffect(() => {
    if (!token) return;

    let cancelled = false;

    assistantApi
      .health()
      .then(() => {
        if (!cancelled) setStatus("ok");
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        if (err instanceof ApiError && err.status === 403) {
          clearAuthToken();
          setStatus("denied");
          return;
        }
        setStatus("ok");
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!token || status === "denied") {
    return <Navigate to="/login" replace />;
  }

  if (status === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Checking session…
      </div>
    );
  }

  return <Outlet />;
}
